import 'slick-carousel';

import createBehavior from '../create-behavior';

const Modernizr = global.Modernizr;

export default () => {
  class ExampleSlider {
    constructor($el, context, settings) {
      $el.slick();

      console.log(`
        Modernizr is enabled, and cssanimations are equal to: "${ Modernizr.cssanimations }".
      `);
    }
  }

  createBehavior('.example-slider', 'ExampleSlider', ExampleSlider);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/exampleSlider.js